import React from 'react';

import SubRoutes from "components/SubRoutes";
import EditLock from "pages/Records/Locks/Edit";
import ListLocks from "pages/Records/Locks/List";

export default function Locks(props) {
  const { match, setBreadcrumbs } = props;
  const pages = [
    {
      name: "Cadeados",
      path: '/:id',
      component: EditLock,
    },
    {
      name: "Cadeados",
      path: '',
      component: ListLocks,
    },
  ];

  return (
    <SubRoutes
      setBreadcrumbs={setBreadcrumbs}
      defaultPage={0}
      pages={pages}
      match={match}
    />
  );
}
